import { IWorkspace } from './workspaces-model';
export interface WorkspacesState {
  loader: boolean;
  workspaces: IWorkspace[];
  workspacesInvites: any[];
  isFirstLoad: boolean;
}

export const initialState: WorkspacesState = {
  loader: false,
  workspaces: null,
  workspacesInvites: [],
  isFirstLoad: true,
};
